<template>
  <section class="page-block insta-block">
    <div class="wide">
      <div class="mid">
        <div class="title-line">
          <span class="left"
            :style="{'background-image': 'url(' + require('@/i/insta/line-end-4.svg') + ')'}"
          ></span>
          <img src="@/i/insta/tracery.svg">
          <span class="right"
            :style="{'background-image': 'url(' + require('@/i/insta/line-end-5.svg') + ')'}"
          ></span>
        </div>
        <p class="title">Instagram</p>
      </div>
      <div class="insta-list">
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-1.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-2.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-3.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-4.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-5.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-6.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-7.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-8.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-9.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-10.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-11.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-12.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-13.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-14.jpg') + ')'}"
        ></div>
        <div
          :style="{'background-image': 'url(' + require('@/content/insta-15.jpg') + ')'}"
        ></div>
        
        <a href="https://www.instagram.com/ballsbarbershopkyiv/" target="_blank">{{ $t('InstaBlock.MoveTo') }}</a>
      </div>
    </div>
    <img class="arrows-scroll arrow-1" src="@/i/welcome/arrow-1.svg" alt="scroll">
  </section>
</template>

<script>

export default {
  name: 'insta-block',
  components: {
  },
  props: {
  }
}
</script>
